import React from 'react';

import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import Card from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import CardContent from '@mui/material/CardContent';
import { FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Checkbox from '@mui/material/Checkbox';

import DropDown from './DropDown';

import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';

function todayISO() {
  const d = new Date();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${mm}-${dd}`;
}

class ListsPriceFilters extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      expanded: false,
      addOpen: false,          // dialog for a new LIST (not products)
      filters_reset: 1,

      filtersCounter: 0,
      countySelected: 0,
      locationGroupSelect: 0,

      checked_active: false,
      checked_withVAT: false,
      vatMode: 'all',

      dateFrom: todayISO(),
      dateTo: todayISO(),

      // creation dialog state
      create_location: "",
      create_currency: "RON",   // default RON
      create_withVAT: true,
      create_dateFrom: todayISO(),
      create_dateTo: "",
      create_active: true,
    };

    this.queryData = { };
    this.productStatus = { "registered": 0, "active": 1, "idle": 2, "discontinued": 9 };
    this.searchKeyword = React.createRef();

    this.handleExpandClick = this.handleExpandClick.bind(this);
    this.toggleFilter = this.toggleFilter.bind(this);
    this.resetStatus = this.resetStatus.bind(this);
    this.removeQueryElement = this.removeQueryElement.bind(this);
    this.addQueryElement = this.addQueryElement.bind(this);
    this.toggleElement = this.toggleElement.bind(this);
    this.searchKey = this.searchKey.bind(this);

    this.resetFilters = this.resetFilters.bind(this);

    this.addCountry = this.addCountry.bind(this);
    this.addCounty = this.addCounty.bind(this);
    this.addLocation = this.addLocation.bind(this);
    this.addDateFrom = this.addDateFrom.bind(this);
    this.addDateTo = this.addDateTo.bind(this);

    // new
    this.openCreate = this.openCreate.bind(this);
    this.closeCreate = this.closeCreate.bind(this);
    this.submitCreate = this.submitCreate.bind(this);
  }

  handleExpandClick ( ) { this.setState({ expanded: !this.state.expanded }); }

  setStatusFilters ( value ) {
    this.setState ( {filters_status_active: value} );
    this.setState ( {filters_status_idle: value} );
    this.setState ( {filters_status_registered: value} );
    this.setState ( {filters_status_discontinued: value} );
  }

  toggleFilter ( filterType, filterName ) {
    switch ( filterType ) {
      case "status":
        this.resetStatus ( filterName );
        this.toggleElement ( "status", filterName, this.productStatus[ filterName ] );
        this.setState ( {checked_active: !this.state.checked_active });
        break;
      case "withVAT":
        this.removeQueryElement ( "withVAT" );
        this.addQueryElement ( "withVAT", filterName );
        this.setState ( {checked_withVAT: !this.state.checked_withVAT });
        break;
      default: break;
    }
    const filtersCounter = Object.keys(this.queryData).length;
    this.setState ( {filtersCounter} );
    if (this.props.applyFilters) this.props.applyFilters ( this.queryData );
  }

  resetStatus ( element ) {
    if ( element !== "active" ) this.setState ( { filters_status_active: 0 } );
    if ( element !== "idle" ) this.setState ( { filters_status_idle: 0 } );
    if ( element !== "registered" ) this.setState ( { filters_status_registered: 0 } );
    if ( element !== "discontinued" ) this.setState ( { filters_status_discontinued: 0 } );
  }

  removeQueryElement ( element ) {
    if (!element) return;
    if (element in this.queryData) {
      if ( this.queryData[ element ] !== null && this.queryData[ element ] !== undefined ) {
        delete this.queryData[ element ];
      }
    }
  }

  addQueryElement ( element, value ) {
    if (!element) return;
    if ( element in this.queryData ) {
      if ( this.queryData[ element ] !== null && this.queryData[ element ] !== undefined && value !== null && value !== undefined ) {
        if ( this.queryData[ element ] !== value ) this.queryData[ element ] = value;
        else delete this.queryData[ element ];
      } else {
        delete this.queryData[ element ];
      }
    } else {
      if ( value !== null && value !== undefined )
        this.queryData[ element ] = value;
      else
        this.queryData[ element ] = 1;
    }
  }

  toggleElement ( prefix, element, value ) {
    let stateName = "filters_" + prefix + "_" + element;
    let status = this.state[ stateName ];
    this.setState ( { [stateName]: !status } );
    if ( prefix === "status" ) element = "status";
    if ( value !== null && value !== undefined ) {
      this.addQueryElement ( element, value );
    } else {
      this.addQueryElement ( element );
    }
  }

  searchKey ( e ) {
    const keyword = e.target.value;
    if ( keyword && keyword.length > 2 ) {
      this.addQueryElement ( "nameLike", keyword );
      if (this.props.applyFilters) this.props.applyFilters ( this.queryData );
    } else {
      if ( "nameLike" in this.queryData ) {
        delete this.queryData[ "nameLike" ];
        if (this.props.applyFilters) this.props.applyFilters ( this.queryData );
      }
    }
    const filtersCounter = Object.keys(this.queryData).length;
    this.setState ( {filtersCounter} );
  }

  addCountry ( key ) {
    if ( key === "0" ) this.removeQueryElement ( "country" );
    else this.addQueryElement ( "country", key );
    const filtersCounter = Object.keys(this.queryData).length;
    this.setState ( {filtersCounter} );
    if (this.props.applyFilters) this.props.applyFilters ( this.queryData );
  }

  addCounty ( key ) {
    if ( key === "0" ) this.removeQueryElement ( "county" );
    else this.addQueryElement ( "county", key );
    const filtersCounter = Object.keys(this.queryData).length;
    this.setState ( {filtersCounter} );
    if (this.props.applyFilters) this.props.applyFilters ( this.queryData );
  }

  addLocation ( key ) {
    if ( key === "0" ) this.removeQueryElement ( "location" );
    else this.addQueryElement ( "location", key );
    const filtersCounter = Object.keys(this.queryData).length;
    this.setState ( {filtersCounter, locationGroupSelect: key} );
    if (this.props.applyFilters) this.props.applyFilters ( this.queryData );
  }

  addDateFrom ( e ) {
    const key = (e && e.target && e.target.value) ? e.target.value : "0";
    if ( key === "0" ) this.removeQueryElement ( "dateFrom" );
    else this.addQueryElement ( "dateFrom", key );
    const filtersCounter = Object.keys(this.queryData).length;
    this.setState ( {filtersCounter, dateFrom: key} );
    if (this.props.applyFilters) this.props.applyFilters ( this.queryData );
  }

  addDateTo ( e ) {
    const key = (e && e.target && e.target.value) ? e.target.value : "0";
    if ( key === "0" ) this.removeQueryElement ( "dateTo" );
    else this.addQueryElement ( "dateTo", key );
    const filtersCounter = Object.keys(this.queryData).length;
    this.setState ( {filtersCounter, dateTo: key} );
    if (this.props.applyFilters) this.props.applyFilters ( this.queryData );
  }

  resetFilters ( ) {
    this.queryData = { };
    this.setState({
      filtersCounter: 0,
      filters_status_active: 0,
      filters_status_idle: 0,
      filters_status_registered: 0,
      filters_status_discontinued: 0,
      checked_active: false,
      checked_withVAT: false,
      vatMode: 'all',
      countySelected: 0,
      locationGroupSelect: 0,
      dateFrom: todayISO(),
      dateTo: todayISO()
    });
    if (this.searchKeyword?.current) this.searchKeyword.current.value = "";
    if (this.props.applyFilters) this.props.applyFilters ( this.queryData );
  }

  cycleVAT = () => {
    const next = this.state.vatMode === 'all' ? 'with' : (this.state.vatMode === 'with' ? 'without' : 'all');
    // update query payload
    if (next === 'all') {
      this.removeQueryElement('withVAT');
    } else if (next === 'with') {
      this.addQueryElement('withVAT', true);
    } else { // 'without'
      this.addQueryElement('withVAT', false);
    }
    const filtersCounter = Object.keys(this.queryData).length;
    this.setState({
      vatMode: next,
      checked_withVAT: (next === 'with'),   // drives the visual check
      filtersCounter
    });
    if (this.props.applyFilters) this.props.applyFilters(this.queryData);
  };

  // --- CREATE NEW LIST (dialog) ---
  openCreate() {
    const t = todayISO();
    this.setState({
      addOpen: true,
      create_dateFrom: this.state.dateFrom || t,
      create_dateTo: this.state.dateTo || "",
      create_withVAT: this.state.checked_withVAT,
      create_active: true
    });
  }
  closeCreate() { this.setState({ addOpen: false }); }

  submitCreate() {
    const payload = {
      location: this.state.create_location,
      currency: this.state.create_currency,
      withVAT: this.state.create_withVAT,
      dateFrom: this.state.create_dateFrom,
      dateTo: this.state.create_dateTo,
      isActive: this.state.create_active,
    };
    if (!payload.location) { alert("Please select a location"); return; }
    if (!payload.currency) { alert("Please select a currency"); return; }
    if (!payload.dateFrom) { alert("Please set a start date"); return; }
    if (this.props.onCreateEmpty) this.props.onCreateEmpty(payload);
    this.closeCreate();
  }

  render() {

    const locations = Object.fromEntries([
      ['0', 'All'],
      ...Object.values(this.props.locations || {})
        .filter(l => l?.iref)
        .sort((a, b) =>
          String(a.name || '').localeCompare(String(b.name || ''), undefined, { sensitivity: 'base' })
        )
        .map(l => [String(l.iref), l.name || l.iref])
    ]);

    let listsCounter = 0;
    if ( this.props && this.props.listsCounter ) listsCounter = this.props.listsCounter;

    return (
      <Card sx={{ borderRadius: '16px', m: 1, backgroundColor: "#214a80" }}>

        <Box sx={{ display:'flex', justifyContent:'flex-start', flexWrap:'wrap', columnGap: 1.5, rowGap: 1.5, alignItems:'center' }}>

          <CardActions disableSpacing sx={{display: "block", textAlign: "flex-end"}}>
            <IconButton aria-label="Add List" title="Add List" onClick={()=> this.openCreate()}>
              <Avatar alt="Add List" sx={{ width: 24, height: 24, color: "#273442" }}>
                {this.state.addOpen ? <FaMinusCircle/> : <FaPlusCircle/>}
              </Avatar>
            </IconButton>
          </CardActions>

          <CardActions disableSpacing sx={{display: "flex", textAlign: "start"}}>
            <Typography variant="body2" sx={{ color: "#e3e3e5", ml: "2px" }}>
              Status:
            </Typography>
            <Checkbox aria-label="Active" title="Active" onClick={() => this.toggleFilter("status", "active")} checked={!!this.state.checked_active} />
          </CardActions>

          <DropDown
            name="Location"
            value={this.state.locationGroupSelect}
            sx={{ color: "#e3e3e5", alignSelf: "center", ml: "2px", mt: 8 }}
            doptions={locations}
            hasIcons={false}
            minWidth={120}
            onDark={true}
            onChangeFunction={this.addLocation}
            InputLabelProps={{ sx : { color: "#e3e3e5" } }}
            size="small"
          />

          <TextField
            label="From"
            type="date"
            value={this.state.dateFrom}
            sx={{ color: "#e3e3e5", alignSelf: "center", ml: "2px", minWidth: 160 }}
            InputLabelProps={{ shrink: true, sx : { color: "#e3e3e5" } }}
            InputProps={{ sx : { color: "#e3e3e5" } }}
            onChange={this.addDateFrom}
            size="small"
          />

          <TextField
            label="To"
            type="date"
            value={this.state.dateTo}
            sx={{ color: "#e3e3e5", alignSelf: "center", ml: "2px", minWidth: 160 }}
            InputLabelProps={{ shrink: true, sx : { color: "#e3e3e5" } }}
            InputProps={{ sx : { color: "#e3e3e5" } }}
            onChange={this.addDateTo}
            size="small"
          />

          {/* <TextField
            id="standard-basic"
            inputRef={this.searchKeyword}
            label="Keywords"
            variant="standard"
            inputProps={{ sx : { color: "#e3e3e5" } }}
            InputLabelProps={{ sx : { color: "#e3e3e5" } }}
            onChange={(e) => this.searchKey( e )}
            sx={{ color: "#e3e3e5", ml: "16px", minWidth: 220 }}
          /> */}

          <TextField
            label="Currency"
            select
            size="small"
            value={this.state.currency || ""}
            onChange={(e) => {
              const v = e.target.value;
              if (!v) this.removeQueryElement("currency");
              else this.addQueryElement("currency", v);
              this.setState({
                currency: v,
                filtersCounter: Object.keys(this.queryData).length,
              });
              if (this.props.applyFilters) this.props.applyFilters(this.queryData);
            }}
            SelectProps={{
              displayEmpty: true,
              renderValue: (v) => (v ? v : "All"),
            }}
            sx={{
              color: "#e3e3e5",
              alignSelf: "center",
              ml: "2px",
              minWidth: 100,
              "& .MuiInputBase-root": {
                height: 40,              // force height (same as small date field)
              },
            }}
            InputLabelProps={{
              shrink: true,
              sx: { color: "#e3e3e5" },
            }}
            InputProps={{
              sx: { color: "#e3e3e5" },
            }}
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="RON">RON</MenuItem>
            <MenuItem value="EUR">EUR</MenuItem>
            <MenuItem value="USD">USD</MenuItem>
          </TextField>

          <Typography variant="body2" sx={{ color: "#e3e3e5", alignSelf: "center", ml: "16px" }}>
            VAT:
          </Typography>
          <Checkbox
            aria-label="VAT filter"
            title={this.state.vatMode === 'all' ? 'All' : (this.state.vatMode === 'with' ? 'With VAT' : 'No VAT')}
            checked={this.state.vatMode === 'with'}
            indeterminate={this.state.vatMode === 'without'}
            onClick={this.cycleVAT}
          />

          <Typography variant="body2" sx={{ color: "#e3e3e5", mt: "auto", ml: "16px" }}>
            Lists: {listsCounter}
          </Typography>

          <Typography variant="body2" sx={{ color: "#e3e3e5", mt: "auto", ml: "16px" }}>
            Filters: {this.state.filtersCounter}
          </Typography>
          { this.state.filtersCounter > 0 ?
            <IconButton aria-label="Remove Filters" title="Remove Filters" onClick={()=> this.resetFilters()} sx={{ mt: "auto" }}>
              <Avatar alt="Remove Filters" sx={{ width: 16, height: 16, color: "#99302e" }}>
                <HighlightOffIcon/>
              </Avatar>
            </IconButton>
            : ""
          }

        </Box>

        <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <Box sx={{ display: 'block', flexDirection: 'row' }}>
              <CardActions disableSpacing sx={{display: "block", textAlign: "left"}}>
                {/* Extra filters can go here */}
              </CardActions>
            </Box>
          </CardContent>
        </Collapse>

        {/* --- Create List Dialog --- */}
        <Dialog open={this.state.addOpen} onClose={()=> this.closeCreate()} fullWidth maxWidth="sm">
          <DialogTitle>Create new price list</DialogTitle>
          <DialogContent dividers>
            <Stack spacing={1.5}>
              {/* Location */}
              <TextField
                label="Location"
                select
                value={this.state.create_location}
                onChange={(e)=> this.setState({ create_location: e.target.value })}
                size="small"
                sx={{ minWidth: 280 }}
              >
                {Object.values(this.props.locations || {})
                  .filter(l => l?.iref)
                  .sort((a, b) =>
                    String(a.name || '').localeCompare(String(b.name || ''), undefined, { sensitivity: 'base' })
                  )
                  .map(l => (
                    <MenuItem key={l.iref} value={l.iref}>
                      {l.name || l.iref}
                    </MenuItem>
                  ))}
              </TextField>

              {/* Currency & VAT */}
              <Stack direction="row" spacing={1} alignItems="center">
                <TextField
                  label="Currency"
                  select
                  value={this.state.create_currency}
                  onChange={(e)=> this.setState({ create_currency: e.target.value })}
                  size="small"
                  sx={{ minWidth: 160 }}
                >
                  <MenuItem value="RON">RON</MenuItem>
                  <MenuItem value="EUR">EUR</MenuItem>
                  <MenuItem value="USD">USD</MenuItem>
                </TextField>
                <Checkbox
                  checked={this.state.create_withVAT}
                  onChange={(e)=> this.setState({ create_withVAT: e.target.checked })}
                />
                <Typography variant="body2" sx={{ color: "#212121" }}>With VAT</Typography>
              </Stack>

              {/* Dates */}
              <Stack direction="row" spacing={1}>
                <TextField
                  label="From"
                  type="date"
                  value={this.state.create_dateFrom}
                  onChange={(e)=> this.setState({ create_dateFrom: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  sx={{ minWidth: 160 }}
                />
                <TextField
                  label="To"
                  type="date"
                  value={this.state.create_dateTo}
                  onChange={(e)=> this.setState({ create_dateTo: e.target.value })}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  sx={{ minWidth: 160 }}
                />
              </Stack>

              {/* Active */}
              <Stack direction="row" spacing={1} alignItems="center">
                <Checkbox
                  checked={this.state.create_active}
                  onChange={(e)=> this.setState({ create_active: e.target.checked })}
                />
                <Typography variant="body2">Active</Typography>
              </Stack>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={()=> this.closeCreate()}>Cancel</Button>
            <Button variant="contained" onClick={()=> this.submitCreate()}>Create</Button>
          </DialogActions>
        </Dialog>

      </Card>
    );
  }
}

export default ListsPriceFilters;
